<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{route.menuName}}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>单号:{{ form.no }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="warehouseName" label="仓库" v-if="getIsView()">
                <el-select @change="warehouseChange" v-model="form.warehouseName" :disabled="!editMode" placeholder="请选择" filterable :filter-method="getWarehousesBySessionWarehouseId" style="width:100%">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>仓库:{{ form.warehouseName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="applyDeptName" label="领用科室" v-if="getIsView()">
                <el-select v-model="form.applyDeptName" :disabled="!editMode" placeholder="请选择" filterable :filter-method="getDepts" @change="applyDeptChange" style="width:100%">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>领用科室:{{ form.applyDeptName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="applyUserName" label="领用人" v-if="getIsView()">
                <el-select v-model="form.applyUserName" :disabled="!editMode" placeholder="请选择" filterable :filter-method="getUsers" @change="applyUserChange" style="width:100%">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>领用人:{{ form.applyUserName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="备注" prop="remark" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备注:{{ form.remark }} </span>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="创建时间" prop="createdTime">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
            </el-col> -->
          </el-row>

          <el-row>

            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="patientNo" label="住院号" v-if="getIsView()">
                <el-select v-model="form.patientNo" filterable :filter-method="getPatientDetailList" @change="patientChange" :disabled="!editMode" style="width:100%">
                  <el-option v-for="(item) in STATIC_PatientDetails" :key="item.id" :label="item.no + ' ' + item.name" :value="item.no"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>住院号:{{ form.patientNo }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="patientId" label="患者姓名" v-if="getIsView()">
                <el-input disabled v-model="form.patientName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>患者姓名:{{ form.patientName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="doctorUserNo" label="医生工号" v-if="getIsView()">
                <el-select v-model="form.doctorUserNo" :disabled="!editMode" placeholder="请选择" filterable :filter-method="getUsers" @change="doctorNameUserChange" style="width:100%">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>医生工号:{{ form.doctorUserNo }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="doctorUserName" label="医生姓名" v-if="getIsView()">
                <el-input disabled v-model="form.doctorUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>医生姓名:{{ form.doctorUserName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalNumber" label="总数量" v-if="getIsView()">
                <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber" type="number"></el-input>
              </el-form-item>
              <span class="viewText" v-else>总数量:{{ form.totalNumber }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" label="总金额" v-if="getIsView()">
                <el-input type="number" disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>总金额:{{ form.totalAmount }} </span>
            </el-col>

          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">移库明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" :disabled="childMultiple" type="danger" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
            <!-- <el-button class="btn default" size="small" v-preventReClick @click="openScanner">点击开始扫描</el-button> -->
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column type="index" width="50" fixed> </el-table-column>
     
            <el-table-column :show-overflow-tooltip="true" fixed prop="productName" label="产品" width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" fixed prop="specName" label="产品规格" width="140"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" fixed prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="manufacturerName" label="生产厂家" width="140"></el-table-column>
            <el-table-column prop="batch" label="批次号" width="120"> </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="minUnit" label="单位" width="120"></el-table-column>
            <el-table-column prop="number" label="数量" width="100"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注" width="200"></el-table-column>
            <el-table-column prop="price" label="单价" width="120"></el-table-column>
            <el-table-column prop="amount" label="金额" width="120"></el-table-column>
            <el-table-column prop="unShareNumber" label="可用数量" width="120"></el-table-column>
            <el-table-column prop="validityDate" label="有效期" width="150">
              <template slot-scope="scope">
                {{ scope.row.validityDate? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}") : ""}}
              </template>
            </el-table-column>
            <el-table-column prop="longTime" label="长期" width="60">
              <template slot-scope="scope">
                {{ scope.row.longTime == 1 ? "是" : "否"}}
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="mainNo" label="主条码" width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="traceNo" label="追溯码" width="180"></el-table-column>

            <el-table-column prop="manufactureDate" label="生产日期" width="150">
              <template slot-scope="scope">
                {{scope.row.manufactureDate ? parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}") : ""}}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="serialNo" label="序列号" width="120"> </el-table-column> -->
            <!-- <el-table-column :show-overflow-tooltip="true" prop="onlineNo" label="挂网号" width="120"></el-table-column> -->
            <el-table-column :show-overflow-tooltip="true" prop="medicalInsuranceCategoryNo" label="医保代码" width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productRegistCertNo" label="注册证号" width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productRegistCertName" label="注册证名称" width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="no" label="请领出库单/领用出库单" width="180"></el-table-column>

          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

      <el-dialog title="产品信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">

          <el-row>
            <el-col :span="6">
              <el-form-item prop="productName" label="产品名称">
                <el-input v-if="isScan" disabled v-model="childForm.productName"></el-input>
                <SelectTable v-if="!isScan" :disabled="!editMode" :columns="unShareColumns" :innerName="childForm.productName" :dataList="unShareProducts" @filterMethod="getShareNumberList" @change="productChange" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="isHaveStock" label="近30天可分摊明细">
                <el-checkbox :disabled="!editMode" v-model="childForm.isLastDays" @change="isLastDaysChange"></el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="mainNo" label="主条码">
                <el-input disabled v-model="childForm.mainNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="traceNo" label="追溯码">
                <el-input disabled v-model="childForm.traceNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>

            <el-col :span="6">
              <el-form-item prop="specName" label="规格型号">
                <el-input disabled v-model="childForm.specName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productRegistCertId" label="产品注册证">
                <el-input disabled v-model="childForm.productRegistCertName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productRegistCertNo" label="注册证号">
                <el-input disabled v-model="childForm.productRegistCertNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="manufacturerName" label="生产厂家">
                <el-input disabled v-model="childForm.manufacturerName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item prop="brand" label="品牌">
                <el-input disabled v-model="childForm.brand"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="minUnit" label="最小单位">
                <el-input disabled v-model="childForm.minUnit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="unit" label="包装单位">
                <el-input disabled v-model="childForm.unit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="packSpec" label="包装规格">
                <el-input disabled v-model="childForm.packSpec"></el-input>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row>

          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="manufactureDate" label="生产日期">
                <el-date-picker disabled v-model="childForm.manufactureDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="validityDate" label="有效期">
                <el-date-picker disabled v-model="childForm.validityDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item prop="longTime" label="长期">
                <el-switch v-model="childForm.longTime" disabled active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="batch" label="批次号">
                <el-input disabled v-model="childForm.batch"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="serialNo" label="序列号">
                <el-input disabled v-model="childForm.serialNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="unShareNumber" label="可用数量">
                <el-input disabled v-model="childForm.unShareNumber"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="number" label="数量">
                <el-input-number :disabled="!editMode" v-model="childForm.number" :min="0" :precision="2" ref="number" :controls="false" placeholder="请填写数量" @change="autoAmount" style="width: 100%"></el-input-number>
                <!-- <el-input :disabled="!editMode" placeholder="请输入数量" type="number" min="0" ref="number" v-model="childForm.number" @input="autoAmount"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="price" label="单价">
                <el-input disabled @input="autoAmount" v-model="childForm.price"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="amount" label="金额">
                <el-input disabled v-model="childForm.amount"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="onlineNo" label="挂网号">
                <el-input disabled v-model="childForm.onlineNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="no" label="请领出库单/领用出库单">
                <el-input disabled v-model="childForm.no"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="remark" label="备注">
                <el-input :disabled="!editMode" v-model="childForm.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button v-if="!isScan && editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
          <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer" class="footer-bottom">
      <my-button v-if="editMode && form.status!=0" class="btn primary" type="primary" v-preventReClick @click="proTemSave">暂 存</my-button>
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import ScanMixin from '@/mixin/outStockScan-mixin'
import {
  GetMoveLibraryById,
  SaveMoveLibrary,
  RejectMoveLibrary,
  GetApplyOutStockUnShareNumber,
  GetCollectOutStockUnShareNumber
} from "@/api";
import { StockCategoryOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import SelectTree from '@/components/select-tree'
import ApproveInfo from "@/components/approve-info";
import { Debounce } from '@/utils/utils'
export default {
  name: "movelibraryEdit",
  mixins: [GetDataMixin, GetDataSpdMixin, ScanMixin],
  components: {
    SelectTable,
    ApproveInfo,
    SelectTree
  },
  data () {
    return {
      form: {},
      GetDataAction: GetMoveLibraryById,
      SaveDataAction: SaveMoveLibrary,
      reject: RejectMoveLibrary,
      // shareQuery: {
      //   keyWord: "",
      //   pageSize: 50,
      //   pageIndex: 1,
      //   applyDeptId: this.form.ownerDept,
      // },
      StockCategoryOptions: StockCategoryOptions,
      rules: {
        warehouseName: [
          { required: true, message: "请选择出库仓库", trigger: "blur" },
        ],
        date: [{ required: true, message: "请选择出库日期", trigger: "blur" }],
        category: [
          { required: true, message: "请选择出库类型", trigger: "blur" },
        ],
        supplierName: [
          { required: true, message: "请选择供应商", trigger: "blur" },
        ],
        applyDeptName: [
          { required: true, message: "请选择请领科室", trigger: "blur" },
        ]
        // remark: [
        //   { required: true, message: "请选择退货理由", trigger: "blur" },
        // ],
      },
      childFormRules: {
        // manufactureDate: [
        //   { required: true, message: "请选择生产日期", trigger: "blur" },
        //   { validator: this.validateManufacturerDate, trigger: 'blur' },
        //   { validator: this.validateDateRange, trigger: 'blur' }
        // ],
        // validityDate: [
        //   { required: true, message: "请选择有效期", trigger: "blur" },
        //   { validator: this.validateValidityDate, trigger: 'blur' },
        //   { validator: this.validateDateRange, trigger: 'blur' }
        // ],
        // batch: [{ required: true, message: "请输入批次号", trigger: "blur" }],
        // productRegistCertId: [{ required: true, message: "请选择产品注册证", trigger: "blur" }],
        // packSpec: [{ required: true, message: "请输入包装规格", trigger: "blur" }],
        productName: [{ required: true, message: "请选择产品", trigger: "blur" }],
        price: [
          { required: true, message: "请输入采购价", trigger: "blur" },
        ],
        number: [
          { required: true, message: "数量不能为空", trigger: "blur" },
          {
            type: "number",
            min: 0.01,
            message: "数量必须大于0",
            trigger: "blur",
          },
          { validator: this.validateLimitNumber, trigger: 'blur' }
        ]
      },
      editMode: false,
      showWorkFlowInfo: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},
      isLastDays: 1,
      isScan: false,
      unShareProducts: [],// 未分摊产品

      defaultProps: {
        children: 'children',
        label: 'name'
      },
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }
    this.getShareNumberList('');
    this.getWarehousesBySessionWarehouseId("");
    this.getDepts('')
    this.getUsers('')
    this.getPatientDetailList('')
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
      this.getShareNumberList('')
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        if (this.form.details != null) {
          this.form.details.forEach((e, index) => {
            e.$index = index + 1;
          });
        }

        this.initWorkFlowProperty(this.form);
        this.getShareNumberList('')

      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        var valdateResult = this.productDetailRepeatValidate(this.form.details)
        if (!valdateResult.flag) {
          this.$my_message(valdateResult.msg, 'warning')
          return;
        }

        this.SaveDataAction(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      // console.log(this.userInfo, "this.userInfo-move");
      this.form = {
        supplierId: "",
        deliveryTime: new Date(),
        // warehouseCategory: "1",
        "warehouseId": this.userInfo.defaultWarehouseId,
        warehouseName: this.userInfo.defaultWarehouseName,
        // warehouseManagerId: this.userInfo.defaultWarehouseManagerId,
        // warehouseManagerName: this.userInfo.defaultWarehouseManagerName,
        // "warehouseId": '',
        // warehouseName: '',
        warehouseManagerId: '',
        warehouseManagerName: '',
        totalNumber: 0,
        totalAmount: 0,
        orderNo: "",
        category: 0,
        remark: "",
        applyDeptName: '',
        applyDeptId: '',
        "balanceStatus": 2,
        outStockCategoryId: '',
        outStockCategoryName: '',
        details: [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        ownerDept: this.userInfo.deptId,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      // if (!this.form.applyDeptId || this.form.applyDeptId == '') {
      //   this.$my_message('请先选择领用科室', 'warning')
      //   return
      // }
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.getProductList('')
      this.isScan = false;
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      this.isScan = false;
      this.getProductRegistCertDetails(this.childForm.productId);
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        no: '',
        "productName": "",
        "specName": "",
        "manufacturerName": "",
        "locationName": "",
        "mainNo": "",
        "traceNo": "",
        supplierProductId: '',
        "productId": '',
        "specId": '',
        productRegistCertId: '',
        "productRegistCertNo": "",
        "onlineNo": "",
        "unit": "",
        "minUnit": "",
        "packSpec": "",
        "manufacturerId": '',
        "locationId": '',
        "manufactureDate": "",
        "batch": "",
        "validityDate": "",
        "serialNo": "",
        "number": 1,
        refundNumber: 0,
        "price": 0,
        "amount": 0,
        "remark": "",
        isLastDays: true,
      };
    },
    isLastDaysChange () {

      this.isLastDays = this.childForm.isLastDays ? 1 : 0;
      console.log(this.isLastDays, this.childForm.isLastDays);
      this.getShareNumberList('')
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm (row) {

      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
      // this.resetDetailFormData();

      this.getShareNumberList('')
    },
    pushChildForm (close) {
      let result = true
      console.log(this.childForm)
      this.$refs["childForm"].validate((valid) => {
        result = valid
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        if (this.childForm.mainNo && this.childForm.traceNo) {
          var childForm = this.childForm
          // 添加行
          let arr = this.form.details.filter(
            (item) => item.mainNo == childForm.mainNo && item.traceNo == childForm.traceNo
          );

          // 添加行记录
          if (arr.length > 0) {
            // 存在则把列表的数据拿过来，并且数量加1
            this.form.details = this.form.details.map((item) => {
              if (
                item.mainNo == childForm.mainNo &&
                item.traceNo == childForm.traceNo
              ) {
                item.packSpec = childForm.packSpec;
                item.locationId = childForm.locationId;
                item.locationName = childForm.locationName;
                item.manufactureDate = childForm.manufactureDate;
                item.batch = childForm.batch;
                item.validityDate = childForm.validityDate;
                item.serialNo = childForm.serialNo;
                item.remark = childForm.remark;
                item.number = childForm.number;
                // item.unUseNumber = childForm.unUseNumber
                item.price = childForm.price;
                item.amount = childForm.amount;
              }
              return item;
            });
          } else {
            // 不存在则添加行记录
            var childForm = JSON.parse(JSON.stringify(this.childForm))
            childForm.$index = this.form.details.length + 1
            this.form.details.push(childForm)
          }
        }
        else {
          if (this.editChildren) {
            let item = this.form.details.find(
              (e) => e.$index == this.childForm.$index
            );
            Object.assign(item, this.childForm);
          }
          else {
            this.form.details.push(this.childForm)
          }
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
          this.count = 0;
          this.isScan = false;
        }
      });
      return result
    },
    // childNumberChange () {
    //   // this.childForm.notReceivedNumber = this.childForm.number
    //   // this.childForm.planOrderNumber = this.childForm.number
    //   // this.childForm.actualOrderNumber = this.childForm.number
    //   this.autoAmount();
    // },
    autoAmount () {
      // this.childForm.billingPrice = this.childForm.price
      this.childForm.amount = (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      // this.childForm.unBillAmount = this.childForm.amount;
    },

    // scan

    // openScanner (ev) {
    //   if (!this.form.warehouseId || this.form.warehouseId == "") {
    //     this.$my_message("请先选择库房", 'warning');
    //     return;
    //   }
    //   this.count = 0;
    //   this.resetDetailFormData();
    //   this.isScan = true;
    //   this.openSubformModal = true;

    //   ev.target.blur();
    // },

    patientChange (val) {
      // this.form.patientId = val
      let arr = this.STATIC_PatientDetails.filter(item => item.no == val)[0]
      if (arr) {
        this.form.patientName = arr.name
        this.form.patientId = arr.id
        this.form.patientNo = arr.no
      }
      else {
        this.form.patientName = ''
        this.form.patientId = ''
        this.form.patientNo = ''
      }
    },

    locationChange (row) {
      row.locationId = row.locationName
    },
    childLocationChange (val) {
      this.childForm.locationId = val
    },
    warehouseChange (val) {
      this.form.warehouseId = val
      let arr = this.STATIC_Warehouses.filter(item => item.id == val)
      if (arr) {
        this.form.warehouseName = arr[0].name
        this.form.warehouseManagerId = arr[0].managerId
        this.form.warehouseManagerName = arr[0].managerName
      }

      this.getShareNumberList("");
    },
    applyDeptChange (val) {
      this.form.applyDeptId = val

    },

    getShareNumberList (keyWord) {

      if (this.system_setting.costAccountingType == 0) {
        this.getApplyOutStockUnShareNumber(keyWord);
      } else {
        // 领用出库
        this.getCollectOutStockUnShareNumber(keyWord);
      }
    },
    applyUserChange (val) {
      this.form.applyUserId = val
    },
    doctorNameUserChange (val) {
      this.form.doctorUserId = val
      let arr = this.STATIC_Users.filter(item => item.id == val)[0]
      if (arr) {
        this.form.doctorUserName = arr.name
        this.form.doctorUserId = arr.id
        this.form.doctorUserNo = arr.no
      }
      else {
        this.form.doctorUserName = ''
        this.form.doctorUserId = ''
        this.form.doctorUserNo = ''
      }
    },
    productChange (row) {
      let id = this.childForm.id
      // let arr = this.STATIC_ApplySupplierProducts.filter((item) => item.id == row.id)
      this.childForm = Object.assign(this.childForm, row)// this.mapper.SupplierProduct2Form(this.childForm, arr[0])
      this.childForm.id = id
      this.childForm.stockId = row.id
      this.childForm.number = 1
      this.childForm.amount = this.childForm.price
      this.childForm.remark = ''

      this.$refs.number.focus();
      this.$refs.number.select();

      this.$refs.childForm.validateField('productName')
    },
    handleCheckChange (node) {
      this.form.outStockCategoryId = node.id;
      this.form.outStockCategoryName = node.name;
    },


    getApplyOutStockUnShareNumber: Debounce(function (keyWord) {
      // query.pageIndex = 1
      // query.pageSize = 50
      // query.applyDeptId = this.form.ownerDept
      // query.isLastDays = this.isLastDays 

      GetApplyOutStockUnShareNumber({ keyWord: keyWord, pageIndex: 1, pageSize: 50, applyDeptId: this.form.ownerDept, isLastDays: this.isLastDays })
        .then(res => {
          this.unShareProducts = res.returnData.data
        })
    }, 500),
    getCollectOutStockUnShareNumber: Debounce(function (keyWord) {
      // query.pageIndex = 1
      // query.pageSize = 50
      // query.applyDeptId = this.form.ownerDept
      // query.isLastDays = this.isLastDays
      GetCollectOutStockUnShareNumber({ keyWord: keyWord, pageIndex: 1, pageSize: 50, applyDeptId: this.form.ownerDept, isLastDays: this.isLastDays })
        .then(res => {
          this.unShareProducts = res.returnData.data
        })
    }, 500),




  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
